<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="mobileVersion ? 'fs' : 'lg-fix-h'" :closable="false" :zindexImportant="2021" :ariaLabel="$t('app.license_dialog_title')" refNameContainer="baseDialogContainerLicense">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('app.license_dialog_title')}}</h2>
        </div>
        <span class="">
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="container-accept-license p-4 ml-2 overflow-y-auto dark:text-darkblue-200 vld-parent" @scroll="onScroll">
        <LicenseContent style="max-height: 55vh" class="mb-8"/>
      </div>
    </template>
    <template slot="footer">
      <div class="flex space-x-2 px-2 bg-white py-1 mt-auto dark:bg-darkblue-900 justify-between w-full items-center">
        <base-button-responsive @click="logout" mode="secondary-phantom-blue" icon="logout" :text="$t('app.cancel')"/>
        <div class="flex">
          <label for="accept" class="mr-2 flex items-center dark:text-darkblue-200">
            <input 
              class='k-checkbox !mr-2 checkbox-lg'
              type="checkbox" id="accept" name="accept" 
              v-model="licenseReaded"
              />
            {{$t('app.accept_license')}}
          </label>
          <base-button @click="downloadLicense" mode="secondary-phantom-blue" :text="$t('app.download')" class="mr-2"/>
          <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.continue_license')"/>
          <a href="/files/EdasNEO-Licencia-uso.pdf" download class="hidden" ref="downloadLicense"/>
        </div>
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from '../base/BaseDialogButton.vue'
import LicenseContent from './LicenseContent.vue'
import { updateLicense } from '@/services/configurations/licenseUser/updateLicense'

export default
{
  name: 'license-dialog',
  components: {
    BaseDialogButton,
    LicenseContent,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      isLoadedData: false,
      licenseReaded: false,
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      if (value) {
        this.licenseReaded= false
      }
    }
  },
  mounted: async function () {
    this.isLoadedData = false
    // TODO
    this.isLoadedData = true
  },
  computed: {
  },
  methods: {
    toggleDialog: async function () {
      if (this.licenseReaded) {
        this.isOpen = !this.isOpen
        this.$emit('toggleDialog')
        try {
          const response = await updateLicense()
          if (response.blnError === true) {
            console.err(response.msgError + ' [Código de error: ' + response.codError + ']')
          }
        } catch (error) {
          console.error(error)
        }
      } else {
        this.doFeedback('Es necesario leer y aceptar el contrato de licencia de uso antes continuar', 'info')
      }
    },
    onScroll ({ target: { scrollTop, clientHeight, scrollHeight } }) {
      // if (scrollTop + clientHeight >= scrollHeight - 5) {
      //   this.licenseReaded = true
      // }
    },
    downloadLicense () {
      this.$refs.downloadLicense.click()
    },
    logout () {
      this.licenseReaded= false
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.$emit('toggleDialogClose')
      this.$store.dispatch('auth/logout')
    }
  }
}
</script>

<style lang="scss" scoped>
.container-accept-license {
  height: 100%;
}
</style>
